<template>
  <div class="buttons">
    <v-btn plain elevation="0" :class="{ preferred: $i18n.locale === 'nl' }" @click="switchLanguage('nl')">NL</v-btn>
    |
    <v-btn plain elevation="0" :class="{ preferred: $i18n.locale === 'en' }" @click="switchLanguage('en')"> EN </v-btn>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "NewLanguageSwitch",
  data() {
    return {
      cookieLocaleToPortalLocaleMap: { "nl-NL": "nl", "en-US": "en" },
      portalLocaleToCookieLocaleMap: { nl: "nl-NL", en: "en-US" },
      userPrefs: {},
    };
  },
  mounted() {
    if (Cookies.get("userPrefs")) {
      this.userPrefs.value = JSON.parse(decodeURIComponent(Cookies.get("userPrefs")));
    } else {
      this.userPrefs.value = {};
    }
    if (!this.userPrefs?.value.locale) {
      this.userPrefs.value.locale = this.portalLocaleToCookieLocaleMap[this.$i18n.locale];
      this.setUserPrefsCookie();
    } else {
      this.$i18n.locale = this.cookieLocaleToPortalLocaleMap[this.userPrefs.value.locale];
    }
  },
  methods: {
    isDeployed() {
      return window.location.protocol === "https:";
    },
    setUserPrefsCookie() {
      let cookieValue = encodeURIComponent(JSON.stringify(this.userPrefs.value));
      if (this.isDeployed()) {
        Cookies.set("userPrefs", cookieValue, { domain: this.getCookieDomain() });
      } else {
        Cookies.set("userPrefs", cookieValue);
      }
    },
    switchLanguage(language) {
      this.$i18n.locale = language;
      this.userPrefs.value.locale = this.portalLocaleToCookieLocaleMap[language];
      this.setUserPrefsCookie();
    },
    getCookieDomain() {
      let cookieDomain = window.location.host;
      // To enable sharing cookies between subdomains, we should get the last two parts of the domain:
      // <SubDomain(s)>.<Second-Level Domain>.<Top-Level Domain> => <Second-Level Domain>.<Top-Level Domain>
      // for example: acc.use.edusources.nl => .edusources.nl
      // note: this also means the cookie will be shared between ACC and PROD environments
      let hostArray = window.location.host.split(".");
      if (hostArray.length > 1) {
        cookieDomain = "." + hostArray.splice(hostArray.length - 2, hostArray.length - 1).join(".");
      }
      return cookieDomain;
    },
  },
};
</script>

<style scoped lang="less">
@import "./../variables";

.buttons {
  display: flex !important;
  align-items: baseline;
  margin-left: -8px;
}

.v-btn {
  border-radius: 0px !important;
  text-transform: none !important;
  min-width: 0 !important;
}
.v-btn__content {
  padding: 0 !important;
}

.v-btn:hover,
.active {
  color: @green;
}

.v-btn--plain {
  padding: 8px !important;
}

.preferred {
  color: @green;
}

@media @mobile {
  margin: 0;
}
</style>
